import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { authFulfilled, setUserHasuraID } from "../../components/authentication/auth.slice";
import { emailAuthCheckCall } from "../../components/authentication/auth.thunk";
import { getTokenKey } from "../../components/authentication/auth.util";
import deviceRegistrationCall from "../../components/deviceRegistration/deviceRegistration.thunk";
import { mobRefreshTokenKey } from "../constants/constants";
import { RootState } from "../store/store";
import { MainState, User, userQueryPayload } from "./main.types";

const initialState: MainState = {
  userAccessToken: null,
  mainAppLoading: true,
  localMobRefreshToken: getTokenKey(),
};

export const mainSlice = createSlice({
  name: "main",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<{ user: User }>) => {
      state.user = action.payload.user;
    },

    setJwt: (state, action: PayloadAction<{ newJwt: string | null }>) => {
      const { newJwt } = action.payload
      if (newJwt === null) {
        localStorage.removeItem(mobRefreshTokenKey)
        state.localMobRefreshToken = null
        return
      }
      localStorage.setItem(mobRefreshTokenKey, newJwt)
      state.localMobRefreshToken = newJwt
    },

    setUserAccessToken: (state, action: PayloadAction<{ newAccessToken: string | null}>) => {
      state.userAccessToken = action.payload.newAccessToken;
    },
    
    deleteUserAccessToken: (state) => {
      state.userAccessToken = null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(authFulfilled, (state, action) => {
      state.localMobRefreshToken = action.payload.userMobToken
    }).addCase(emailAuthCheckCall.fulfilled, (state, action) => {
      state.localMobRefreshToken = action.payload.userMobToken
    }).addCase(setUserHasuraID, (state, action: PayloadAction<userQueryPayload>) => {
      state.user = action.payload.userData
      state.device = action.payload.userData.devices[0]
    }).addCase(deviceRegistrationCall.fulfilled, (state, action) => {
      state.device = action.payload
    })
  }
});

// Action creators are generated for each case reducer function
export const userSelector = (state: RootState) => state.main.user;
export const deviceSelector = (state: RootState) => state.main.device;
export const deviceIdSelector = (state: RootState) => state.main.device?._id;
export const userIdSelector = (state: RootState) => state.main.user?.id;
export const {
  setUser,
  setJwt,
  setUserAccessToken,
  deleteUserAccessToken
} = mainSlice.actions;

export default mainSlice.reducer;
